import type { ButtonHTMLAttributes } from "react";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

const variantClass: Record<ButtonVariant, string> = {
  primary: "btn btn--primary",
  secondary: "btn btn--secondary",
  ghost: "btn btn--ghost",
  danger: "btn btn--danger",
};

/** Class string for styling a router `<Link>` or `<a>` as a button. */
export const buttonClass = (variant: ButtonVariant = "secondary"): string => variantClass[variant];

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
};

export const Button = ({ variant = "secondary", className, type = "button", ...rest }: ButtonProps) => (
  <button type={type} className={[variantClass[variant], className].filter(Boolean).join(" ")} {...rest} />
);
